module.exports = __webpack_public_path__ + "static/media/tut-4.5b9cd935.png";